import React, { Component } from "react";
import axios from "axios";
import { ROOT_URL } from "../../actions/root_url";
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";

class ShippingInfoConfirmModal extends Component {
  constructor() {
    super();
    // this.state = {
    //   shippingInfo: props.shippingInfo,
    //   selectedAddressId: props.selectedAddressId,
    // };
  }

  componentDidMount() {
  }

  handleInputFieldChange = ({ name, value }) =>
    this.setState({ [name]: value });

  handleSubmit = () => {};

  showSelectedShippingAddress = () => {
    let address = '';
    if (!this.props.salesShippingCustomerDetails || !this.props.salesShippingCustomerDetails.Shipping || !this.props.CustomerDetail_id) {
      return 'No shipping information found!';
    }
    const CustomerDetail_id = this.props.CustomerDetail_id.value || this.props.CustomerDetail_id;
    this.props.salesShippingCustomerDetails.Shipping.forEach(shippingAddress => {
      if (shippingAddress.CustomerDetail_id === CustomerDetail_id) {
        return address = `${shippingAddress.AddressName || ''} ${shippingAddress.Street || ''} ${shippingAddress.City || ''} ${shippingAddress.State || ''} ${shippingAddress.Zip || ''}`
      }
    })
    return address;
  }
  render() {

    const {
      handleReturnClick,
      handleSaveClick,
    } = this.props;
    return (
      <div>
        <Row>
          <h4>This Sales Order will Be Shippied To: {this.showSelectedShippingAddress()}</h4>
        </Row>
        <Row className="centerStyle" style={{ marginTop: "40px" }}>
          <Button
            bsStyle="primary"
            className="mr-1"
            onClick={(e) => {
              handleReturnClick();
            }}
          >
            <Translate value="return" />
          </Button>
          <Button
            bsStyle="success"
            style={{ marginLeft: '20px'}}
            disabled={!this.props.CustomerDetail_id}
            onClick={(e) => {
              handleSaveClick()
            }}
          >
            <Translate value="save" />
          </Button>
        </Row>
      </div>
    );
  }
}

export default ShippingInfoConfirmModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/ShippingInfoConfirmModal.jsx